import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { CheckboxState } from './Switcher.state';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { Wrapper, SwitcherWrapper, Input, Slider } from 'src/components/SwitcherNew/Switcher.style';

interface PropsType {
    state: FormInputState<boolean, boolean>;
    label: string;
    disabled?: boolean;
    onChange?: () => void;
    marginBottom?: string;
    dataTest?: string;
}
class State {
    public constructor(
        private readonly switcherState: CheckboxState,
        private readonly props: PropsType
    ) {}
    public onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        this.switcherState.handleChange(event);
        if (this.props.onChange !== undefined) {
            this.props.onChange();
        }
    };
}
export const Switcher = observer((props: PropsType) => {
    const { state, label, disabled = false, marginBottom, dataTest } = props;
    const [switcherState] = useState(() => new CheckboxState(state));
    const [localState] = React.useState(() => new State(switcherState, props));

    return (
        <Wrapper
            isDisabled={disabled}
            marginBottom={marginBottom}
            data-test={dataTest}
        >
            <SwitcherWrapper>
                <Input
                    type='checkbox'
                    checked={switcherState.value}
                    readOnly
                    onChange={disabled ? undefined : localState.onChange}
                />
                <Slider />
            </SwitcherWrapper>
            <Label>{label}</Label>
        </Wrapper>
    );
});
